export enum BadgeStep {
  INFO = "info",
  QUALIFICATION_SELECTION = "qualification_selection",
  STATE_SELECTION = "state_selection",
}

export const STEP_TITLES = {
  [BadgeStep.INFO]: "Work Badge",
  [BadgeStep.QUALIFICATION_SELECTION]: "Select the Role for Your Badge",
  [BadgeStep.STATE_SELECTION]: "Select the License State",
} as const;

export const BUTTON_LABELS = {
  VIEW_BADGE: "View Badge",
  CONTINUE: "Continue",
} as const;

export const ERROR_MESSAGES = {
  NO_ACTIVE_QUALIFICATIONS: "You don't have any active roles or licenses to create a badge for.",
} as const;

export const INFO_DESCRIPTION = `
Some workplaces require you to wear a badge during your shift. You can create a badge for any role or license you have.`;
